import { Field } from './Field.js'
import { generateItemName, sortItemsByName, addElem } from '../SharedUtils.js'

export class ComponentArray extends Array {
  constructor(cls, opts) {
    super()
    this.cls = cls
    this.creationFunc = opts?.creationFunc ?? (() => cls.create())
    // Override for arrays where a new item can't just go at the end — e.g.
    // WallBuilder.layers, where the last item is a fixed boundary layer and
    // new layers must be inserted before it. Only used for unnamed items
    // (named items are always inserted sorted by name).
    this.insertFunc = opts?.insertFunc ?? ((arr, item) => addElem(arr, item))
  }

  createNew(name) {
    // Library items (wall types, window types, Spaces, Schedules, ...) must be
    // created through their class's static createType(), same as the UI does:
    // it gives the item a unique project id (the plain creationFunc leaves id
    // 0, so every new item would share it) and adds it to the project's array
    // for that class, which is this array.
    if (typeof this.cls.createType === 'function') {
      const newItem = this.cls.createType()
      if (!this.includes(newItem)) {
        throw new Error(`${this.cls.name}.createType() added the new item to a different array than this one.`)
      }
      if (name) {
        newItem.name.value = name
        sortItemsByName(this)
      }
      return newItem
    }

    const newItem = this.creationFunc()
    if (newItem.name instanceof Field) {
      if (name) {
        newItem.name.value = name
      } else {
        const tableInfo = this.cls.getTableInfo?.()
        const typeName = tableInfo?.typeName ?? this.cls.name
        const newItemName = tableInfo?.newItemName || undefined
        newItem.name.value = generateItemName(typeName, this, newItemName)
      }
      this.push(newItem)
      sortItemsByName(this)
    } else {
      this.insertFunc(this, newItem)
    }
    return newItem
  }
}
